export default __webpack_public_path__ + "static/media/Inter-Variable.e05c5f3d.ttf";